import {
    MatomoProvider,
    createInstance,
    useMatomo,
} from '@datapunt/matomo-tracker-react';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './containers/App/App';
import './i18n';
import * as serviceWorker from './serviceWorker';
import store from './store';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import 'react-modal-video/scss/modal-video.scss';
import 'react-toastify/dist/ReactToastify.min.css';
import 'swiper/swiper.scss';
import './doc/scss/master.scss';

const isLocalhost = window.location.hostname === 'localhost';

const matomoInstance = !isLocalhost
    ? createInstance({
          urlBase: 'https://analytics.gesundheitsticket.de',
          siteId: 2,
          trackerUrl: 'https://analytics.gesundheitsticket.de/matomo.php',
          userId: `user-${Math.floor(Math.random() * 10000) + 1}`,
          linkTracking: false,
      })
    : null;

ReactDOM.render(
    <MatomoProvider value={matomoInstance}>
        <Provider store={store}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </Provider>
    </MatomoProvider>,

    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
